<template>
    <li class="swipeout no-hairlines">
        <!-- Usual list element wrapped with "swipeout-content" -->
        <a href="#" class='item-link'>
            <div class="swipeout-content">
                <!-- Your list element here -->
                <div class="item-content" @click="_click">
                    <div class="item-inner">
                        <div class="item-title-row">
                            <div class="item-title">
                                <tempalte v-if="$slots.title">
                                    <slot name="title"></slot>
                                </tempalte>
                                <template v-else>
                                    {{title}}
                                </template>
                            </div>
                            <div class="item-after">
                                <template v-if="$slots.after">
                                    <slot name="after"></slot>
                                </template>
                                <template v-else>
                                    {{after}}
                                </template>
                            </div>
                        </div>
                        <div class="item-subtitle">
                            <template v-if="$slots.subtitle">
                                <slot name="subtitle"></slot>
                            </template>
                            <template v-else>
                                {{subtitle}}
                            </template>
                        </div>
                        <div class="item-text">
                            <template v-if="$slots.text">
                                <slot name="text"></slot>
                            </template>
                            <template v-else>
                                {{text}}
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <slot></slot>
        </a>
    </li>
</template>

<script>
  export default {
    props: {
      swipeout: {
        type: Boolean,
        default: false
      },
      title: String,
      after: String,
      subtitle: String,
      text: String,
      link: {
        type: Boolean,
        default: false
      }
    },
    name: '',
    methods: {
      _click () {
        this.$emit('click')
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.$$(this.$el).on('swipeout:deleted', () => {
          this.$emit('swipeout:deleted')
        })
      })
    }
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "listItem.scss";
</style>